const defaultValueFaq = [{
	id: 'q2',
	pergunta: 'Como funciona o sistema?',
	resposta: {
		html: '<h3 style="text-align: left;"><span style="color: rgb(0, 0, 0);">1. Como posso fazer um pedido?</span></h3><p><span style="color: rgb(43, 43, 43);">Basta acessar nossa página de produtos, escolher o item desejado, clicar em <strong>“Adicionar ao carrinho”</strong> e seguir para o <strong>checkout</strong>. Você poderá escolher a forma de pagamento e confirmar o endereço de entrega antes de finalizar.</span></p><p></p><p></p><h3 style="text-align: left;">2. Quais formas de pagamento são aceitas?</h3><p style="text-align: left;"><span style="color: rgb(43, 43, 43);">Aceitamos pagamentos via <strong>cartão de crédito, PIX, boleto bancário e PayPal</strong>. Em alguns casos, é possível parcelar suas compras em até 6x sem juros.</span></p>',
		json: {
			type: 'doc',
			content: [
				{
					type: 'heading',
					attrs: {
						textAlign: 'left',
						level: 3,
					},
					content: [
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(0, 0, 0)',
									},
								},
							],
							text: '1. Como posso fazer um pedido?',
						},
					],
				},
				{
					type: 'paragraph',
					attrs: {
						textAlign: null,
					},
					content: [
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
							],
							text: 'Basta acessar nossa página de produtos, escolher o item desejado, clicar em ',
						},
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
								{
									type: 'bold',
								},
							],
							text: '“Adicionar ao carrinho”',
						},
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
							],
							text: ' e seguir para o ',
						},
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
								{
									type: 'bold',
								},
							],
							text: 'checkout',
						},
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
							],
							text: '. Você poderá escolher a forma de pagamento e confirmar o endereço de entrega antes de finalizar.',
						},
					],
				},
				{
					type: 'paragraph',
					attrs: {
						textAlign: null,
					},
				},
				{
					type: 'paragraph',
					attrs: {
						textAlign: null,
					},
				},
				{
					type: 'heading',
					attrs: {
						textAlign: 'left',
						level: 3,
					},
					content: [
						{
							type: 'text',
							text: '2. Quais formas de pagamento são aceitas?',
						},
					],
				},
				{
					type: 'paragraph',
					attrs: {
						textAlign: 'left',
					},
					content: [
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
							],
							text: 'Aceitamos pagamentos via ',
						},
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
								{
									type: 'bold',
								},
							],
							text: 'cartão de crédito, PIX, boleto bancário e PayPal',
						},
						{
							type: 'text',
							marks: [
								{
									type: 'textStyle',
									attrs: {
										fontSize: '',
										color: 'rgb(43, 43, 43)',
									},
								},
							],
							text: '. Em alguns casos, é possível parcelar suas compras em até 6x sem juros.',
						},
					],
				},
			],
		},
		plain: '1. Como posso fazer um pedido?\n\nBasta acessar nossa página de produtos, escolher o item desejado, clicar em “Adicionar ao carrinho” e seguir para o checkout. Você poderá escolher a forma de pagamento e confirmar o endereço de entrega antes de finalizar.\n\n\n\n\n\n2. Quais formas de pagamento são aceitas?\n\nAceitamos pagamentos via cartão de crédito, PIX, boleto bancário e PayPal. Em alguns casos, é possível parcelar suas compras em até 6x sem juros.',
	},
}]

export default defaultValueFaq;